import DefaultList from "@/components/DefaultList";
import DictionaryCreator from "@/components/dictionaries/DictionaryCreator";
import DictionaryEditor from "@/components/dictionaries/DictionaryEditor";
import { PATH_DICTS_DISABILITY_CERTIFICATES } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import {
  readDisabilityCertificate,
  writeDisabilityCertificate,
} from "@/schemas/disabilityCertificate";
import { DisabilityCertificateService } from "@/services/disabilityCertificate";
import {
  ReadDisabilityCertificate,
  WriteDisabilityCertificate,
} from "@/types/disabilityCertificate";
import { FileText } from "lucide-react";

const id = Module.DisabilityCertificates;
const path = PATH_DICTS_DISABILITY_CERTIFICATES;
const ns = "disabilityCertificates";

const config: DictionaryConfig<
  ReadDisabilityCertificate,
  WriteDisabilityCertificate
> = {
  id,
  ns,
  service: DisabilityCertificateService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeDisabilityCertificate,
  defaultValues: {
    code: "",
    description: "",
  },
  breadcrumbField: "code",
  Icon: FileText,
  List: () => (
    <DefaultList<ReadDisabilityCertificate>
      schema={readDisabilityCertificate}
      name={ns}
      fetchList={DisabilityCertificateService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.DisabilityCertificates },
      }}
    />
  ),
  Creator: DictionaryCreator,
  Editor: DictionaryEditor,
};

export default config;
